import React, { useEffect, useState } from 'react'
import { MainTitle } from '../components/MainTitle'
import "../css/Reference.css"
import * as imagesdata from '../imagesdata'
import { motion } from 'framer-motion';
const Reference = () => {

  const [fontSize, setFontSize] = useState(0);
  const [columns, setColumns] = useState(4);
  const [cardSize, setCardSize] = useState({ width: 250 });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let cols = 4;
      let cardWidth = 250;

      const newFontSize = Math.max(15, Math.min(25, (width / 25)));

      if (width < 1000) {
        cols = 2;
        cardWidth = (width - 100) / cols;
      } else if (width < 1350) {
        cols = 3;
        cardWidth = (width - 250) / cols;
      }

      setColumns(cols);
      setCardSize({ width: cardWidth });
      setFontSize(newFontSize);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const referenceData = [
    { id: 1, name: 'Traflux', logoSrc: imagesdata.TersLogo },
    { id: 2, name: 'Atlas Üniversitesi', logoSrc: imagesdata.AtlasLogo },
    { id: 3, name: 'Traflux', logoSrc: imagesdata.TersLogo },
    { id: 4, name: 'Atlas Üniversitesi', logoSrc: imagesdata.AtlasLogo },
    { id: 5, name: 'Traflux', logoSrc: imagesdata.TersLogo },
    { id: 6, name: 'Atlas Üniversitesi', logoSrc: imagesdata.AtlasLogo },
    { id: 7, name: 'Traflux', logoSrc: imagesdata.TersLogo },
    { id: 8, name: 'Atlas Üniversitesi', logoSrc: imagesdata.AtlasLogo },
  ];

  return (
    <div>
      <MainTitle headerImage={imagesdata.HeaderAboutUs} />
      <div className='main-text-bold-header' style={{ fontSize: `${fontSize - 2}px` }}>
        <h1>
          <span className='main-title-dark-text-outline'>Referanslarımız</span>
        </h1>
      </div>

      <div className="reference-grid-container" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>

        {referenceData.map((reference, index) => {
          const horizontalIndex = index % columns;
          const delay = 0.1 + horizontalIndex * 0.1;
          return (
            <motion.div
              key={referenceData.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.3, delay: delay }}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className='reference-item-container'>
                <div key={reference.id} className="reference-item" style={{ width: cardSize.width, height: cardSize.width }}>
                  <div>
                    <img src={reference.logoSrc} alt={reference.name} className="reference-image" />
                    <p className="reference-name">{reference.name}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          )
        })}

      </div>
    </div>
  )
}

export default Reference